import { Col, Row, Button, Carousel } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/login.scss";
import LoginAIImage from '../assets/images/icons/Login_AI_animation.gif';
import { Auth } from "../libs/utilities/helpers/Auth";

const Login = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleMicrosoftLogin = () => {
        setLoading(true);

        const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
        const tenantId = process.env.REACT_APP_MICROSOFT_TENANT_ID;
        const redirectUri = process.env.REACT_APP_BASE_URL;
        // const scope = `${clientId}/.default`;
        const scope = `openid profile email offline_access User.Read api://${clientId}/access_user`;

        // const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
        const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${scope}`;
        // Small delay to ensure loader shows before redirect
        setTimeout(() => {
            window.location.href = authUrl;
        }, 100);
    };

    useEffect(() => {
        if (Auth.isLoggedIn()) {
            navigate("/");
        } else {
            Auth.deregister();
        }
    }, [navigate]);

    return (
        <div className="login-container">
            <Row className="login-wrapper">
                <Col xs={24} lg={14} className="login-form-container">
                    <div className="login-innerdiv">
                        <div className="logo-container">
                            <span className="logo">GALAXY</span>
                        </div>
                        <p className="greetings">Hello! How can I assist you today.</p>
                        <p className="login-heading">Log in</p>
                        <Button
                            className="login-button"
                            size="large"
                            type="primary"
                            loading={loading}
                            onClick={handleMicrosoftLogin}
                        >
                            <span>Log in with Microsoft</span>
                        </Button>
                    </div>
                </Col>

                <Col xs={0} lg={10} className="carousel-container">
                    <img className='AnimationImg' alt="Galaxy AI" src={LoginAIImage} />
                    <Carousel effect="fade" className="custom-carousel">
                        <div className="carousel-slide">
                            <h3 className="carousel-page">Summarizer</h3>
                            <p className="carousel-text">Transforms call recordings, chat conversations, emails, and past interactions into concise summaries, offering a quick snapshot of customer needs and preferences.</p>
                        </div>
                        <div className="carousel-slide">
                            <h3 className="carousel-page">Report Analyzer</h3>
                            <p className="carousel-text">Use it to convert financial data into practical insights and concise summaries, highlighting key indicators and trends.</p>
                        </div>
                        <div className="carousel-slide">
                            <h3 className="carousel-page">Enterprise GPT</h3>
                            <p className="carousel-text">Web app to chat over your documents using GenAI—search, explore, and converse with your files seamlessly.</p>
                        </div>
                    </Carousel>
                </Col>
            </Row>
        </div>
    );
};

export default Login;
